import ServiceGraphQL from 'src/service/gql-service';
import { createInvoice } from 'src/graphql';

const serviceGraphQL = new ServiceGraphQL();

/** Action creators */
export const CreateInvoice = (data) => {
  const params = {
    query: createInvoice.QUERY,
    variables: {
      record: data
    }
  };
  return serviceGraphQL
    .post(params)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw err;
    });
};
